var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"ml-1",attrs:{"loading":_vm.loading,"color":_vm.color,"depressed":""},on:{"click":_vm.synchronise}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(" "+_vm._s(_vm.icon)+" ")]),_vm._v(" "+_vm._s(_vm.text)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }